import React from "react";
import styled from "styled-components";
import Paragraph from "../components/Paragraph";
import Col from "../components/Col";
import SubHeadline from "../components/SubHeadline";
import Strong from "../components/Strong";

export default () => (
  <Col>
    <SubHeadline>
      <Strong>ANSCHRIFT</Strong>
    </SubHeadline>
    <Paragraph>
      Thomas Raithel <br />
      Römerstraße 117 <br />
      65205 Wiesbaden <br />
      USt-IdNr. DE281797351 <br />
    </Paragraph>
  </Col>
);



// WEBPACK FOOTER //
// ./src/components/ContactOffline.js